import React from 'react';
import { Modal, Button, DatePicker, Menu, Dropdown, Icon, Input, Checkbox, message } from 'antd';
import moment from 'moment';
import { asiapacific, americas, europe, middleeast, africa } from './countries.js'
const CheckboxGroup = Checkbox.Group;

class ModalUsers extends React.Component {

  constructor() {
    super();
    this.state = {
      //    group: "",
      //    groupDropdown: "",
      type: [],
      typeDropdown: '',
      program: [],
      name: '',
      region: 'Africa',
      country: '',
      description: '',
      address: '',
      phone: '',
      email: '',
      id: '',
      products: null,
      savedProduct: '',
      history:[],
      trial: false,
      academicYear: 'August - July'
    }
  }

  updateData = () => {
    // console.log('this.props.data.products',this.props.data.products)
    if (this.props.mode == 'edit') {
      let program;
      let type;
      if (this.props.data.program.includes('&')) {
        program = this.props.data.program.split('&')
      } else {
        program = this.props.data.program
      }

      if (this.props.data.type.includes('&')) {
        type = this.props.data.type.split('&')
      } else {
        type = this.props.data.type
      }

      this.setState({
        // group: this.props.data.group,
        // groupDropdown: this.props.data.group,
        type: type,
        typeDropdown: this.props.data.type,
        program: program,
        name: this.props.data.name,
        region: this.props.data.region,
        products: this.props.data.products,
        country: this.props.data.country,
        description: this.props.data.description,
        address: this.props.data.address,
        phone: this.props.data.phone,
        email: this.props.data.email,
        id: this.props.data.id,
        savedProduct: this.props.data.products,
        history:this.props.data.history || [],
        academicYear: this.props.data.academicYear || 'August - July'
      })
    }
  }

  cancel = () => {
    this.setState({
      // group: "",
      type: '',
      program: '',
      name: '',
      region: '',
      country: '',
      description: '',
      savedProduct: '',
      address: '',
      phone: '',
      email: '',
      id: '',
      products: null,
      history:[],
      trial: false,
      academicYear: 'August - July'
    }, () => { this.props.cancel() }
    )
  }

  save = () => {
    let data = {}
    data = {
      // group: this.state.group,
      type: this.state.type,
      program: this.state.program,
      name: this.state.name,
      region: this.state.region,
      country: this.state.country,
      description: this.state.description,
      address: this.state.address,
      phone: this.state.phone,
      email: this.state.email,
      products: this.state.products,
      id: this.state.id,
      savedProduct: this.state.savedProduct,
      history:this.state.history,
      trial: this.state.trial,
      academicYear: this.state.academicYear
    }
    this.props.save(data, this.props.mode)
  }

  countries = () => {
    let countries;
    if (this.state.region == 'Asia Pacific') {
      countries = asiapacific
    } else if (this.state.region == 'Americas') {
      countries = americas
    } else if (this.state.region == 'Europe') {
      countries = europe
    } else if (this.state.region == 'Middle East') {
      countries = middleeast
    } else {
      countries = africa
    }

    return (
      <Menu onClick={(e) => this.setState({ country: e.item.props.children })}>
        {countries.map((country, i) =>
          <Menu.Item key={i}>{country}</Menu.Item>
        )}
      </Menu>
    )
  }

  checkFields = () => {
    if (
      this.state.type.length === 0 ||
      this.state.program.length === 0 ||
      this.state.name === '' ||
      this.state.region === '' ||
      this.state.country === '' ||
      //this.state.products === null ||
      this.state.description === '' ||
      this.state.address === '' ||
      this.state.phone === '' ||
      this.state.email === ''
    ) {
      message.error('All fields are mandatory');
    } else {
      this.save()
    }
  }

  onChangeCheckbox = (checkbox, checkedValues) => {
    if (checkbox === 'trial') {
      this.setState({ trial: checkedValues.length == 0 ? false : true })
    } else {
      this.setState({ products: checkedValues })
    }
  }

  render() {

    const { t, mode } = this.props

    const plainOptions = ['SkillTracker', 'ServiceTracker'];

    const region = (
      <Menu onClick={(e) => this.setState({ region: e.item.props.children, country: '' })}>
        <Menu.Item key="0">{t('Africa')}</Menu.Item>
        <Menu.Item key="1">{t('Asia Pacific')}</Menu.Item>
        <Menu.Item key="2">{t('Americas')}</Menu.Item>
        <Menu.Item key="3">{t('Europe')}</Menu.Item>
        <Menu.Item key="4">{t('Middle East')}</Menu.Item>
      </Menu>
    );

    const academicYear = (
      <Menu onClick={(e) => this.setState({ academicYear: e.key })}>
        <Menu.Item key="January - December">{t('January - December')}</Menu.Item>
        <Menu.Item key="August - July">{t('August - July')}</Menu.Item>
      </Menu>
    );

    const programmes = [
      { label: 'PYB', value: 'PYB' },
      { label: 'DP', value: 'DP' },
      { label: 'CP', value: 'CP' },
      { label: 'MYP', value: 'MYP' },
      { label: 'Another curriculum', value: 'Other' }
    ];

    const schooltypes = [
      { label: 'Goverment / State', value: 'Goverment / State' },
      { label: 'Private', value: 'Private' },
      { label: 'Private International', value: 'Private International' }
    ];

    return (
      <div>
        <Modal
          className="edituser"
          visible={this.props.open}
          onOk={this.checkFields}
          onCancel={this.cancel}
        >

          {/*
          <h3 style={heading}>School group</h3>
          <div style={{display: 'inline-flex'}}>
            <Dropdown overlay={schoolgroup}>
              <Button style={buttonStyle}>
                {this.state.groupDropdown == "" ? 'School Group' : this.state.groupDropdown} <Icon type="down" />
              </Button>
            </Dropdown>
            <Input
              style={{
                marginLeft: 20,
                marginRight: 20,
                width: '100%',
                borderBottom: '2px solid #F4F3F4',
                borderRadius: '0px',
                visibility: this.state.groupDropdown == 'Other' ? 'visible' : 'hidden'
              }}
              onChange={(e) => this.setState({group: e.target.value})}
              placeholder="Please specify"
              />
          </div>
        */}

          <h3 style={heading}>{t('School Type')}</h3>
          <CheckboxGroup options={schooltypes} style={{ marginBottom: '20px' }} onChange={(e) => this.setState({ type: e })} />
          <h3 style={heading}>{t('Program')}</h3>
          <CheckboxGroup options={programmes} style={{ marginBottom: '20px' }} onChange={(e) => this.setState({ program: e })} />
          <h3 style={heading}>{t('School Name')}</h3>
          <Input
            style={input}
            onChange={(e) => this.setState({ name: e.target.value })}
            value={this.state.name}
          />
          <h3>{t('Products')}</h3>
          <div>
            <CheckboxGroup options={plainOptions} value={this.state.products} onChange={(e) => this.onChangeCheckbox('products', e)} />
            <br /><br />
          </div>
          {mode && mode == 'add' &&
            <div>
              <h3>{t('Trial')}</h3>
              <div>
                <CheckboxGroup options={[{ label: 'Auto deactivate after 37 days', value: 'trial' }]} value={this.state.trial ? ['trial'] : []} onChange={(e) => this.onChangeCheckbox('trial', e)} />
                <br /><br />
              </div>
            </div>
          }
          <h3 style={heading}>{t('Academic Year')}</h3>
          <Dropdown overlay={academicYear} placement="bottomRight">
            <Button style={{ width: '100%', borderRadius: 3 }}>
              {this.state.academicYear} <Icon type="down" />
            </Button>
          </Dropdown>
          <h3 style={heading}>{t('Region')}</h3>
          <Dropdown overlay={region} placement="bottomRight">
            <Button style={{ width: '100%', borderRadius: 3 }}>
              {this.state.region} <Icon type="down" />
            </Button>
          </Dropdown>
          <h3 style={heading}>{t('School Country')}</h3>
          <Dropdown overlay={this.countries()} placement="bottomLeft">
            <Button style={{ width: '100%', borderRadius: 3 }}>
              {this.state.country == '' ? 'School country' : this.state.country} <Icon type="down" />
            </Button>
          </Dropdown>
          <h3 style={heading}>{t('School Description')}</h3>
          <Input
            style={input}
            onChange={(e) => this.setState({ description: e.target.value })}
            value={this.state.description}
          />
          <h3 style={heading}>{t('School Address')}</h3>
          <Input
            style={input}
            onChange={(e) => this.setState({ address: e.target.value })}
            value={this.state.address}
          />
          <h3 style={heading}>{t('Contact Phone Number')}</h3>
          <Input
            style={input}
            onChange={(e) => this.setState({ phone: e.target.value })}
            value={this.state.phone}
          />
          <h3 style={heading}>{t('Contact Email Address')}</h3>
          <Input
            style={input}
            onChange={(e) => this.setState({ email: e.target.value })}
            value={this.state.email}
          />

        </Modal>
      </div>
    )
  }
}
const buttonStyle = {
  width: '300px'
}
const input = {
  width: '100%',
  borderBottom: '2px solid #F4F3F4',
  borderRadius: '3px'
}
const heading = {
  fontSize: '18px',
  marginTop: '20px'
}

export default ModalUsers;



// WEBPACK FOOTER //
// ./src/components/ModalSchools/index.jsx